module.exports = __webpack_public_path__ + "static/media/planeta-her.43bdd064.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/exhibitors/planeta-her.png
// module id = 511
// module chunks = 0